module.exports = __webpack_public_path__ + "ismv-static/media/mrestate-intro-notebook.2355ccbf.png";